import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DOG_SEARCH_URL, DOG_URL } from "./Constants.js"
import DogFeed from "./DogFeed"
import StatusPopup from "./StatusPopup.js"
import { cap_Name, valid_Name } from "./Validate"

const DogTags = () => {
	const d = new Date()
	const [customers, setCustomers] = useState([])
	const [newCust, setNewCust] = useState(false)
	const [infoCust, setInfoCust] = useState(false)
	const [findCust, setFindCust] = useState(false)
	const [newDog, setNewDog] = useState(false)
	const [listDogs, setListDogs] = useState(false)
	const [listTags, setListTags] = useState(false)
	const [listSheep, setListSheep] = useState(false)
	const [sheep_goats, setSheepGoats] = useState(false)
	const [fees, setFees] = useState(false)

	// Form fields for fee schedule
	const [formDogs, setFormDogs] = useState("")
	const [formSheep, setFormSheep] = useState("")
	const [formGoats, setFormGoats] = useState("")
	const [formKennels, setFormKennels] = useState("")
	const [formLateFiling, setFormLateFiling] = useState("")
	const [formNoFiling, setFormNoFiling] = useState("")
	const [formReturnedCheck, setFormReturnedCheck] = useState("")
	const [formViciousDog, setFormViciousDog] = useState("")
	const [formLostTag, setFormLostTag] = useState("")
	const [formImpound, setFormImpound] = useState("")

	const [searched, setSearched] = useState(false)
	const [error, setError] = useState("")
	const [formLastname, setFormLastname] = useState("")
	const [LN_bgc, setLN_bgc] = useState()
	const [LN_Valid, setLN_Valid] = useState(true)
	const [dogSex, setDogSex] = useState("M")

	const navigate = useNavigate()
	// easy-peasy
	const Token = useStoreState((state) => state.Token)
	const AuthUser = useStoreState((state) => state.AuthUser)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const setHeaderCity = useStoreActions((actions) => actions.setHeaderCity)
	const setHeaderUser = useStoreActions((actions) => actions.setHeaderUser)
	const setSearchBy = useStoreActions((actions) => actions.setSearchBy)
	const SearchBy = useStoreState((state) => state.SearchBy)
	const setSearchPrompt = useStoreActions((actions) => actions.setSearchPrompt)
	const SearchPrompt = useStoreState((state) => state.SearchPrompt)
	// const setFormLastname = useStoreActions((actions) => actions.setFormLastname)

	function CustomerAdd() {
		setNewCust(true)
		setInfoCust(false)
		setFindCust(false)
		setNewDog(true)
		setListDogs(false)
		setListSheep(true)
		setListTags(false)
		setSheepGoats(true)
		setFees(false)
	}
	function CustomerFind() {
		setNewCust(false)
		setInfoCust(true)
		setFindCust(true)
		setNewDog(false)
		setListDogs(true)
		setListSheep(false)
		setListTags(false)
		setSheepGoats(false)
		setFees(false)
	}
	function TagManage() {
		setNewCust(false)
		setInfoCust(false)
		setFindCust(false)
		setNewDog(false)
		setListDogs(false)
		setListSheep(false)
		setListTags(true)
		setSheepGoats(false)
		setFees(false)
	}
	function FeeShow() {
		setNewCust(false)
		setInfoCust(false)
		setFindCust(false)
		setNewDog(false)
		setListDogs(false)
		setListSheep(false)
		setListTags(false)
		setSheepGoats(false)
		setFees(true)
	}
	const handleLastnameChange = (e) => {
		setFormLastname(cap_Name(e.target.value))
		if (valid_Name(e.target.value) && e.target.value.length > 0) {
			setLN_bgc({})
			setLN_Valid(true)
			setSearchBy("lastname")
			setSearchPrompt(e.target.value.toLowerCase())
		} else {
			setLN_bgc({ backgroundColor: "pink" })
			setLN_Valid(false)
			setSearchBy("")
			setSearchPrompt("")
		}
		setError("")
	}
	async function handleCustomers(e) {
		if (e) e.preventDefault()
		try {
			const request = {
				login_id: Token.login_id,
				client_id: Token.client_id,
				expires: Token.expires,
				search_by: "lastname",
				search_value: SearchPrompt,
			}
			console.log(request)
			let data
			if (SearchBy !== "") {
				;({ data } = await axios.post(DOG_SEARCH_URL, request))
			} else {
				;({ data } = await axios.post(DOG_URL, request))
			}
			setCustomers(data)
			setSearched(true)
			if (data.length === 0) {
				setTimeout(() => setSearched(false), 3000)
			}
		} catch (err) {
			setError(err.message)
			// Code 422 indicates user tried to refresh page
			// React does not handle page refreshes so trigger a new login
			if (err.message === "Request failed with status code 401") {
				setError("Timeout")
			}
			if (err.message === "Request failed with status code 404") {
				setError("404")
			}
			if (err.message === "Request failed with status code 422") {
				setError("422")
			}
			if (err.message === "Request failed with status code 500") {
				setError("500")
			}
		}
	}
	const handleSelect = (dog) => {
		// Populate the customer information fields from the selected row
		// Column order matches SQL: id, acct_id, last_name, first_name, m_initial,
		// email, phone, number_addr1, street_addr1, addr2, city_name, state_code,
		// zip, cnty_district, paperless, dt_established, dt_terminated
		document.getElementById("acct").value = dog[1] ?? ""
		document.getElementById("tin").value = ""
		document.getElementById("lastname").value = dog[2] ?? ""
		document.getElementById("firstname").value = dog[3] ?? ""
		document.getElementById("m_initial").value = dog[4] ?? ""
		document.getElementById("email").value = dog[5] ?? ""
		document.getElementById("phone").value = dog[6] ?? ""
		document.getElementById("streetnum").value = dog[7] ?? ""
		document.getElementById("streetname").value = dog[8] ?? ""
		document.getElementById("addr2").value = dog[9] ?? ""
		document.getElementById("city").value = dog[10] ?? ""
		document.getElementById("state").value = dog[11] ?? ""
		document.getElementById("zip").value = dog[12] ?? ""
		document.getElementById("district").value = dog[13] ?? ""
		document.getElementById("paperless").checked = dog[14] === true
	}

	useEffect(() => {
		if (!error) return

		const timer = setTimeout(() => {
			if (error === "404") {
				setError("")
				navigate("/dog")
			} else {
				setHeaderCity("CR Cloud Technology")
				setHeaderUser("None")
				setLoggedIn(false)
				navigate("/login")
			}
		}, 2000)
		return () => clearTimeout(timer)
	}, [error, navigate, setHeaderCity, setHeaderUser, setLoggedIn])

	return (
		<main className="Main">
			{findCust && (
				<fieldset className="search_options">
					<legend>Search Options (Tax Year: {d.getFullYear()})</legend>
					<form
						className="InputForm"
						name="InputForm"
						onSubmit={handleCustomers}
					>
						<span style={{ display: "block", marginTop: "0.5rem" }}>
							<label htmlFor="account_number" style={{ display: "block" }}>
								By Account #:
							</label>
							<input
								type="text"
								id="account_number"
								placeholder="nnnnnn Enter Key"
								onKeyDown={(e) => e.key === "Enter" && handleCustomers(e)}
							/>
						</span>
						<span style={{ display: "block", marginTop: "0.5rem" }}>
							<label
								htmlFor="last_name"
								style={{ display: "block", marginTop: "15px" }}
							>
								By Last Name:
							</label>
							<input
								type="text"
								id="last_name"
								placeholder="Min 2 characters. Enter Key"
								style={LN_bgc}
								onChange={(e) => handleLastnameChange(e)}
								onKeyDown={(e) => e.key === "Enter" && handleCustomers(e)}
							/>
						</span>
						<span style={{ display: "block", marginTop: "0.5rem" }}>
							<label
								htmlFor="tag_number"
								style={{ display: "block", marginTop: "15px" }}
							>
								By Tag #:
							</label>
							<input
								type="text"
								id="tag_number"
								placeholder="nnnnn Enter Key"
								maxLength={5}
								onKeyDown={(e) => e.key === "Enter" && handleCustomers(e)}
							/>
						</span>
						<span
							style={{
								display: "block",
								marginTop: "calc(1rem + 10px)",
								textAlign: "center",
							}}
						></span>

						{searched && customers.length === 0 && (
							<StatusPopup message="No records found. You may now add a new record." />
						)}
					</form>
				</fieldset>
			)}
			{infoCust && (
				<fieldset className="search_results">
					<legend>Dog List</legend>
					<DogFeed customers={customers} onSelect={handleSelect} />
				</fieldset>
			)}

			{searched && customers.length > 0 && (
				<fieldset className="search_results">
					<legend>Search Results</legend>
					<DogFeed customers={customers} onSelect={handleSelect} />
				</fieldset>
			)}

			{infoCust && (
				<fieldset id="cust_info">
					<legend>Customer Information</legend>
					<table id="cust_tbl">
						<tr style={{ backgroundColor: "transparent" }}>
							<td style={{ width: "50px" }}>
								<label htmlFor="acct">Account:</label>
								<input type="text" id="acct" name="acct"></input>
							</td>
							<td style={{ width: "50px" }}>
								<label htmlFor="tin">TIN:</label>
								<input type="text" id="tin" name="tin"></input>
							</td>
							<td style={{ width: "50px" }}>
								<label htmlFor="district">District:</label>
								<select id="district" name="district" style={{ width: "100%" }}>
									<option value=""></option>
									<option value="BEACH BOTTOM">BEACH BOTTOM</option>
									<option value="BETHANY">BETHANY</option>
									<option value="BUFFALO">BUFFALO</option>
									<option value="CROSS CREEK">CROSS CREEK</option>
									<option value="FOLLANSBEE">FOLLANSBEE</option>
									<option value="WEIRTON">WEIRTON</option>
									<option value="WELLSBURG">WELLSBURG</option>
									<option value="WINDSOR HEIGHTS">WINDSOR HEIGHTS</option>
								</select>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="firstname">First Name:</label>
								<input type="text" id="firstname" name="firstname"></input>
							</td>
							<td>
								<label htmlFor="m_initial">Middle Initial:</label>
								<input type="text" id="m_initial" name="m_initial"></input>
							</td>
							<td>
								<label htmlFor="lastname">Last Name:</label>
								<input type="text" id="lastname" name="lastname"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="streetnum">Street Number:</label>
								<input type="text" id="streetnum" name="streetnum"></input>
							</td>
							<td>
								<label htmlFor="streetname">Street Name:</label>
								<input type="text" id="streetname" name="streetname"></input>
							</td>
							<td>
								<label htmlFor="addr2">Address 2:</label>
								<input type="text" id="addr2" name="addr2"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="city">City:</label>
								<input type="text" id="city" name="city"></input>
							</td>
							<td>
								<label htmlFor="state">State:</label>
								<input type="text" id="state" name="state"></input>
							</td>
							<td>
								<label htmlFor="zip">ZIP:</label>
								<input type="text" id="zip" name="zip"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="email">Email:</label>
								<input type="text" id="email" name="email"></input>
							</td>
							<td>
								<label htmlFor="phone">Phone:</label>
								<input type="text" id="phone" name="phone"></input>
							</td>
							<td style={{ textAlign: "center" }}>
								<label htmlFor="paperless" style={{ display: "block" }}>
									Paperless:
								</label>
								<input type="checkbox" id="paperless" name="paperless"></input>
							</td>
						</tr>
					</table>
				</fieldset>
			)}
			{newCust && (
				<fieldset id="cust_add">
					<legend>New Customer</legend>
					<table id="cust_tbl">
						<tr style={{ backgroundColor: "transparent" }}>
							<td style={{ width: "50px" }}>
								<label htmlFor="acct">Account:</label>
								<input type="text" id="acct" name="acct"></input>
							</td>
							<td style={{ width: "50px" }}>
								<label htmlFor="district">District:</label>
								<select id="district" name="district" style={{ width: "100%" }}>
									<option value=""></option>
									<option value="BEACH BOTTOM">BEACH BOTTOM</option>
									<option value="BETHANY">BETHANY</option>
									<option value="BUFFALO">BUFFALO</option>
									<option value="CROSS CREEK">CROSS CREEK</option>
									<option value="FOLLANSBEE">FOLLANSBEE</option>
									<option value="WEIRTON">WEIRTON</option>
									<option value="WELLSBURG">WELLSBURG</option>
									<option value="WINDSOR HEIGHTS">WINDSOR HEIGHTS</option>
								</select>
							</td>
							<td style={{ textAlign: "center" }}>
								<label htmlFor="paperless" style={{ display: "block" }}>
									Paperless:
								</label>
								<input type="checkbox" id="paperless" name="paperless"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="firstname">First Name:</label>
								<input type="text" id="firstname" name="firstname"></input>
							</td>
							<td>
								<label htmlFor="m_initial">Middle Initial:</label>
								<input type="text" id="m_initial" name="m_initial"></input>
							</td>
							<td>
								<label htmlFor="lastname">Last Name:</label>
								<input type="text" id="lastname" name="lastname"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="streetnum">Street Number:</label>
								<input type="text" id="streetnum" name="streetnum"></input>
							</td>
							<td>
								<label htmlFor="streetname">Street Name:</label>
								<input type="text" id="streetname" name="streetname"></input>
							</td>
							<td>
								<label htmlFor="addr2">Address 2:</label>
								<input type="text" id="addr2" name="addr2"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="city">City:</label>
								<input type="text" id="city" name="city"></input>
							</td>
							<td>
								<label htmlFor="state">State:</label>
								<input type="text" id="state" name="state"></input>
							</td>
							<td>
								<label htmlFor="zip">ZIP:</label>
								<input type="text" id="zip" name="zip"></input>
							</td>
						</tr>
						<tr>
							<td>
								<label htmlFor="email">Email:</label>
								<input type="text" id="email" name="email"></input>
							</td>
							<td>
								<label htmlFor="phone">Phone:</label>
								<input type="text" id="phone" name="phone"></input>
							</td>
							<td>
								<button type="button" className="saveBtn">
									Save New
								</button>
							</td>
						</tr>
					</table>
				</fieldset>
			)}

			{newDog && (
				<fieldset className="dogs">
					<legend>New Dog</legend>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="sex" style={{ display: "block" }}>
							Sex:
						</label>
						<select
							id="sex"
							name="sex"
							defaultValue="M"
							onChange={(e) => setDogSex(e.target.value)}
						>
							<option value="M">M</option>
							<option value="F">F</option>
						</select>
					</span>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="age" style={{ display: "block" }}>
							Age:
						</label>
						<select id="age" name="age" defaultValue="">
							<option value=""></option>
							{[...Array(14)].map((_, i) => (
								<option key={i + 1} value={i + 1}>
									{i + 1}
								</option>
							))}
							<option value="15+">15+</option>
						</select>
					</span>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="name" style={{ display: "block" }}>
							Dog Name:
						</label>
						<input type="text" id="name" name="name" />
					</span>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="hair_color" style={{ display: "block" }}>
							Hair Color:
						</label>
						<input type="text" id="hair_color" name="hair_color" />
					</span>
					<br />
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="hair_length" style={{ display: "block" }}>
							Hair Length:
						</label>
						<select id="hair_length" name="hair_length" defaultValue="">
							<option value=""></option>
							<option value="Short">Short</option>
							<option value="Medium">Medium</option>
							<option value="Long">Long</option>
						</select>
					</span>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="breed" style={{ display: "block" }}>
							Breed:
						</label>
						<input type="text" id="breed" name="breed" />
					</span>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="size" style={{ display: "block" }}>
							Size:
						</label>
						<select id="size" name="size" defaultValue="">
							<option value=""></option>
							<option value="Small">Small</option>
							<option value="Medium">Medium</option>
							<option value="Large">Large</option>
						</select>
					</span>
					<span
						style={{
							display: "inline-block",
							marginRight: "15px",
							textAlign: "center",
						}}
					>
						<label htmlFor="spayed" style={{ display: "block" }}>
							{dogSex === "F" ? "Spayed:" : "Neutered:"}
						</label>
						<input type="checkbox" id="spayed" name="spayed" />
					</span>
					<span style={{ display: "inline-block", textAlign: "center" }}>
						<label htmlFor="vicious" style={{ display: "block" }}>
							Vicious:
						</label>
						<input type="checkbox" id="vicious" name="vicious" />
					</span>
					<button type="button" className="saveBtn">
						Save New
					</button>
				</fieldset>
			)}

			{sheep_goats && (
				<fieldset className="sheep_goats">
					<legend>Sheep & Goats</legend>
					<span style={{ display: "inline-block", marginRight: "15px" }}>
						<label htmlFor="sheep" style={{ display: "block" }}>
							Sheep:
						</label>
						<input
							type="number"
							id="sheep"
							name="sheep"
							maxLength={5}
							style={{ width: "5ch" }}
						/>
					</span>
					<span style={{ display: "inline-block" }}>
						<label htmlFor="goats" style={{ display: "block" }}>
							Goats:
						</label>
						<input
							type="number"
							id="goats"
							name="goats"
							maxLength={5}
							style={{ width: "5ch" }}
						/>
					</span>
				</fieldset>
			)}

			{fees && (
				<fieldset className="fees">
					<legend>Fee Schedule</legend>
					<table className="dogfees">
						<thead>
							<tr>
								<th>ITEM</th>
								<th>{d.getFullYear()}</th>
							</tr>
							<tr>
								<td>Dogs</td>
								<td>
									<input
										type="text"
										id="fee_dogs"
										name="fee_dogs"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Sheep</td>
								<td>
									<input
										type="text"
										id="fee_sheep"
										name="fee_sheep"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Goats</td>
								<td>
									<input
										type="text"
										id="fee_goats"
										name="fee_goats"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Kennels</td>
								<td>
									<input
										type="text"
										id="fee_kennels"
										name="fee_kennels"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Late Filing</td>
								<td>
									<input
										type="text"
										id="fee_late_filing"
										name="fee_late_filing"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>No Filing</td>
								<td>
									<input
										type="text"
										id="fee_no_filing"
										name="fee_no_filing"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Returned Check</td>
								<td>
									<input
										type="text"
										id="fee_returned_check"
										name="fee_returned_check"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Vicious Dog</td>
								<td>
									<input
										type="text"
										id="fee_vicious_dog"
										name="fee_vicious_dog"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Lost Tag</td>
								<td>
									<input
										type="text"
										id="fee_lost_tag"
										name="fee_lost_tag"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
							<tr>
								<td>Impound</td>
								<td>
									<input
										type="text"
										id="fee_impound"
										name="fee_impound"
										style={{ width: "7ch", marginLeft: "25%" }}
									/>
								</td>
							</tr>
						</thead>
					</table>
				</fieldset>
			)}

			{listTags && (
				<fieldset className="tag_list">
					<legend>Tag List</legend>
				</fieldset>
			)}

		</main>
	)
}

export default DogTags
